export enum ChartDataLabelsTypeEnum {
    WEEKDAYS = 'WEEKDAYS',
    DATES = 'DATES',
    DEFAULT = 'DEFAULT',
}
